import React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: Node,
  className?: string,
  mode: ModeType,
  schemeMode?: 'dark' | 'light',
  type?: 'line' | 'card',
};
export const TabPanel = ({ children, className, schemeMode, type, ...rest }: Props) => {

  return (
    <StyledTabPanel className={className} schemeMode={schemeMode} type={type} {...rest}>
      {children}
    </StyledTabPanel>
  );
};

TabPanel.tabsRole = 'TabPanel';

const StyledTabPanel = styled('div')`
  color: ${({ theme, schemeMode }) => (schemeMode === 'dark' ? theme.color.white : theme.color.black)};
`;
